import styled from 'styled-components'

import { BodyM } from '@/components/Text.tsx'
import { textSizeM } from '@/styles/theme/fonts.ts'

const LabelStyled = styled.label`
  ${textSizeM};
  color: ${({ theme }) => theme.colors.common.black};
  display: flex;
  text-decoration: none;
  margin-bottom: 8px;
`

const InputCaption = styled(BodyM)`
  margin-top: 10px;
`

export { InputCaption, LabelStyled as Label }
